<tool-drawer-container (openFormDialog)="openDialog()">
  <program-bottleneck-form class="form-slot"></program-bottleneck-form>

  <tool-header
    class="tool-header"
    headerTitle="Program Bottleneck Courses"
    subtitle="Displays 5 courses with lowest pass rates based on a program for different years and semesters"
  ></tool-header>

  <program-bottleneck-content class="main-content"></program-bottleneck-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Program Bottleneck Courses'
      )
    "
  ></related-links>
</tool-drawer-container>
